import type { Enums, Nullable } from "@msuite/utils/types";
import type { IconName } from "./icons";

export function getAttendanceWorksiteIconName(
	type: Nullable<Enums<"attendanceWorksiteType">>,
): IconName {
	switch (type) {
		case "home-office":
			return "Home";
		case "office":
			return "Building";
		case "project-site":
			return "Construction";
		case "warehouse":
			return "Warehouse";
		case "commute":
			return "Car";
		default:
			return "CircleQuestionMark";
	}
}
